// extracted by mini-css-extract-plugin
export default {"categoryCard":"CategoryCard_categoryCard__LhgBz","link":"CategoryCard_link__92Gsa"};